// src/hooks/useAddNativeClasses.ts
import { useEffect } from "react";
function useAddNativeClasses(isNative, platform) {
  useEffect(() => {
    if (isNative) {
      document.documentElement.classList.add("group", "is-native");
    }
    if (platform) {
      document.documentElement.classList.add(`is-native-${platform}`);
    }
  }, [isNative, platform]);
}
export {
  useAddNativeClasses
};
//# sourceMappingURL=index.js.map
